import { render } from "./Widget.vue?vue&type=template&id=78980f12&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"

import "./Widget.vue?vue&type=style&index=0&id=78980f12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78980f12"]])

export default __exports__